import { ExportToCsv } from 'export-to-csv';
import { coerceExportCellValue } from './exportValueUtils';

/**
 * Build CSV rows keyed by header labels.
 * Callers usually pass headerName[] + records keyed by fieldName;
 * export-to-csv looks up row[header], so we map positionally when needed.
 *
 * Numeric values are left as JS numbers so export-to-csv writes them
 * unquoted — Excel can then sum CSV columns.
 */
function buildCsvRecords(columns, records) {
    const isColumnDefs = columns.length > 0
        && typeof columns[0] === 'object'
        && (columns[0].headerName || columns[0].header);

    const headers = isColumnDefs
        ? columns.map((col) => col.headerName || col.header)
        : columns;

    const fieldKeys = isColumnDefs
        ? columns.map((col) => col.fieldName || col.dataKey || col.headerName || col.header)
        : null;

    return (records || []).map((record) => {
        if (record === null || record === undefined || typeof record !== 'object') {
            return {};
        }
        const keys = Object.keys(record);
        const csvRow = {};
        headers.forEach((header, index) => {
            let value;
            if (fieldKeys) {
                value = record[fieldKeys[index]];
            } else if (Object.prototype.hasOwnProperty.call(record, header)) {
                value = record[header];
            } else {
                value = record[keys[index]];
            }
            csvRow[header] = coerceExportCellValue(value);
        });
        return csvRow;
    });
}

export function exportAsCSV(columns, records, filename) {
    const isColumnDefs = columns.length > 0
        && typeof columns[0] === 'object'
        && (columns[0].headerName || columns[0].header);

    const headers = isColumnDefs
        ? columns.map((col) => col.headerName || col.header)
        : columns;

    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers,
    };

    if (filename) {
        csvOptions.filename = String(filename).replace(/\.csv$/i, '');
    }

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(buildCsvRecords(columns, records));
}
